const de = {
  failedLoading: 'Modulwahl konnte nicht geladen werden.',
  filter: {
    search: 'Suchen...',
    completed: 'Zustand',
    courseOfStudy: 'Studiengänge',
    takesPlace: 'Findet statt',
    options: {
      takesPlace: 'Findet statt',
      takesNotPlace: 'Findet nicht statt',
      complete: 'Vollständig',
      incomplete: 'Unvollständig'
    }
  },
  sort: {
    nameAsc: 'Name aufsteigend',
    nameDesc: 'Name absteigend'
  },
  modulePreview: {
    tabTitle: 'Wahlvorschau',
    addSelectionModuleTitle: 'Modul hinzufügen',
    startSelection: 'Anmeldephase beenden',
    publishSelection: 'Wahlergebnisse veröffentlichen',
    archiveSelection: 'Wahl archivieren',
    startSelectionError: `Mindestens ein Modul muss zur Modulwahl, alle Module müssen vollständig sein und die Wahl muss gestartet haben.`,
    publishSelectionError:
      'Der Status der Wahl muss im Nachrückverfahren sein und die Wahl darf nicht bereits veröffentlicht sein.',
    startEmailNotificationError: {
      alreadyNotified: 'Die Studenten wurden bereits über die Wahlergebnisse informiert.',
      notYetPublished:
        'Die Wahl muss bereits veröffentlicht sein, damit die Studenten über die Wahlergebnisse benachrichtigt werden dürfen.'
    },
    archiveSelectionError:
      'Der Status der Wahl muss Abgeschlossen sein, damit die Wahl von einem Wahladmin, oder einem Sekretariatsmitarbeiter archiviert werden kann.',
    addModuleSelection: 'Modul hinzufügen',
    modulesTitle: 'Module',
    selectionState: 'Status der Wahl',
    noItems: 'Es wurden keine Module gefunden',
    confirm: {
      finalSelectionTitle: 'Finale Berechnung der Wahl starten',
      finalSelectionBody:
        'Wollen Sie wirklich die finale Berechnung der Wahl starten? Hiermit endet die Wahlphase und die Nachrückphase beginnt.',
      publishSelectionTitle: 'Veröffentlichung der Wahlergebnisse',
      publishSelectionBody:
        'Studierende werden via Dashboard Benachrichtigung (in der Benachrichtigungsglocke) über die Veröffentlichung der Wahlergebnisse informiert.\n Es werden zu diesem Zeitpunkt keine E-Mail-Benachrichtigungen versendet, auch nicht, falls Teilnehmerlisten durch einen Administrator bearbeitet werden.\n Wenn Studenten aus der Warteliste nachrücken, aus einem Modul gelöscht oder in ein Modul hinzugefügt werden, wird ebenfalls keine Benachrichtigung ausgelöst.\n\n Möchten Sie die Wahlergebnisse jetzt veröffentlichen?',
      archiveSelectionTitle: 'Wahl archivieren',
      archiveSelectionBody:
        'Wollen Sie wirklich die Wahl archivieren? Hiermit kann die Wahl nicht mehr bearbeitet werden.',
      startEmailNotificationTitle: 'Email-Benachrichtigung für Wahl: "{{title}}" starten',
      startEmailNotificationBody:
        'Alle an der Wahl teilnehmenden Studenten werden ab jetzt über die aktuellen Wahlergebnisse informiert.\n\n Dies bedeutet, dass sie direkt via E-Mail über das Nachrücken, Hinzufügen oder Löschen in einem Modul informiert werden.\n\n Möchten Sie die E-Mail-Benachrichtigung starten und alle teilnehmenden Studenten über den laufenden Stand der Wahl informieren?'
    },
    success: {
      publishSelection: 'Die Wahlergebnisse wurden erfolgreich veröffentlicht.',
      archiveSelection: 'Die Wahl wurde erfolgreich archiviert.',
      sendEmailNotification: 'Die Studenten wurden erfolgreich über die Wahlergebnisse informiert.'
    },
    error: {
      publishSelection: 'Die Wahlergebnisse konnten nicht veröffentlicht werden.',
      archiveSelection: 'Die Wahl konnte nicht archiviert werden.',
      sendEmailNotification:
        'Die Studenten konnten nicht über die Wahlergebnisse informiert werden.'
    },
    buttons: {
      edit: 'Bearbeiten',
      delete: 'Löschen',
      template: 'Als Vorlage verwenden'
    },
    information: {
      title: 'Wahlinformationen',
      dischargeByStudentsUntil: 'Austragung durch Studenten:',
      until: 'Bis',
      contentVisibleFrom: 'Inhalte sichbar ab:',
      activeInAllCommunities: 'Diese Wahl in allen Communities aktivieren',
      publishedAt: `Ergebnisse veröffentlicht am:`,
      generalInfo: 'Allgemeine Hinweise',
      electionTips: 'Wahltipps',
      create: {
        alerts: { saveFailed: 'Fehler beim Hinzufügen des Moduls' },
        invalidError: 'Bitte geben Sie mindestens ein Modul an'
      }
    },
    explanatoryLegendText: 'Module, die abgesagt wurden und daher nicht stattfinden werden.',
    create: {
      addedModules: 'Ausgewählte Module:',
      selectModules: 'Module auswählen:',
      selectAllModules: 'Alle Module auswählen',
      modulePreferences: 'Diese Module werden hinzugefügt:',
      noItemsSelected: 'Keine Module ausgewählt',
      noItems: 'Keine Modulvorlagen gefunden',
      alerts: { saveFailed: 'Hinzufügen der Module fehlgeschlagen' },
      steps: {
        selectModules: 'Modulauswahl',
        confirmation: 'Bestätigen'
      },
      selectModulesField: 'Ausgewählte Module',
      invalidError: 'Bitte mindestens ein Modul auswählen'
    },
    deleteModuleSelection: 'Wahl löschen',
    deleteModuleSelectionDescription:
      'Sind Sie sicher, dass Sie diese Wahl löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.'
  },
  occupancy: { tabTitle: 'Modulbelegung' },
  studentList: {
    tabTitle: 'Studentenbelegung',
    table: {
      mtrNumber: 'Matrikelnummer',
      lastName: 'Nachname',
      firstName: 'Vorname',
      courseOfStudy: 'Studiengang',
      semester: 'Semester',
      modulePreferences: 'Gewünschte Module',
      desiredNumberOfModules: 'Gewünschte Anzahl',
      lotteryResult: 'Erhaltene Module',
      studentHasBeenRemoved: 'Der Student wurde aus dem Modul entfernt'
    },
    filter: {
      studentsWithInsufficientModules: 'Studenten mit zu wenig erhaltenen Modulen'
    },
    export: {
      exportAllStudents: 'Exportiere alle Studenten',
      exportAllStudentsWithoutModules:
        'Exportiere alle Studenten, welche nicht ihre gewünschte Anzahl an Modulen erhalten haben'
    }
  }
};

export default de;
export type ModuleSelectionsDetailTranslation = typeof de;
